import React, { useState } from 'react';
import Navbar from './Navbar';
import Header from './Header';
import Footer from './Footer';
import { useForm } from 'react-hook-form';
import { registerStudent } from '../../firebase/admin';
import Error from '../Error';
import Success from '../Success';
import SelectProgram from './SelectProgram'
import SelectCohort from './SelectCohort';

const Student = () => {

    const { register, handleSubmit, reset } = useForm();
    const [ isLoading, setIsLoading ] = useState(false);
    const [ errorMgs, setErrorMgs ] = useState("");
    const [ isErrorFlaq, setIsErrorFlaq ] = useState(false);
    const [ successMgs, setSuccessMgs ] = useState("");
    const [ isSuccessFlaq, setIsSuccessFlaq ] = useState(false);

    const createNewStudent = async (data) => {
        setIsLoading(true);
        let newUser;
        try {
            newUser = await registerStudent(data);
            reset();
            setSuccessMgs("Student Registered Successfully");
            setIsSuccessFlaq(true)
            setIsLoading(false);
        }
        catch (error) {
            setErrorMgs(error.message);
            setIsErrorFlaq(true)
            console.log(error);
            setIsLoading(false);
        }
    };

    return (
        <div className="mdk-drawer-layout js-mdk-drawer-layout" data-push data-responsive-width="992px">
            <div className="mdk-drawer-layout__content page-content">
                <Header />
                <div className="pt-32pt">
                    <div className="container page__container d-flex flex-column flex-md-row align-items-center text-center text-sm-left">
                        <div className="flex d-flex flex-column flex-sm-row align-items-center">
                            <div className="mb-24pt mb-sm-0 mr-sm-24pt">
                                <h2 className="mb-0">Register Student</h2>
                                <ol className="breadcrumb pt-12pt m-0">
                                    <li className="breadcrumb-item"><a href="admin-dashboard">Home</a></li>
                                    <li className="breadcrumb-item"><a href="students">Students</a></li>
                                    <li className="breadcrumb-item active">
                                        Student
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Page Content */}
                <div className="container page__container page-section">
                    <div>
                        <div className="page-separator">
                            <div className="page-separator__text">Personal Information</div>
                        </div>
                        <form onSubmit={handleSubmit(createNewStudent)}>
                            {isErrorFlaq ? <Error message={errorMgs} /> : ""}
                            {isSuccessFlaq ? <Success message={successMgs} /> : ""}
                            <br />
                            <div className="col-md-8 mb-24pt">
                                <div className="form-group">
                                    <label className="form-label">Email address</label>
                                    <input type="email" className="form-control" defaultValue="" placeholder="Enter email address ..." {...register('emailAddress')} required />
                                </div>
                                <div className="form-group">
                                    <label className="form-label">Last name</label>
                                    <input type="text" className="form-control" defaultValue="" placeholder="Enter last name ..." {...register('lastName')} required />
                                </div>
                                <div className="form-group">
                                    <label className="form-label">First name</label>
                                    <input type="text" className="form-control" defaultValue="" placeholder="Enter first name ..." {...register('firstName')} required />
                                </div>
                                <div className="form-group">
                                    <label className="form-label">Student Number</label>
                                    <input type="text" className="form-control" defaultValue="" placeholder="Enter student number ..." {...register('studentNumber')} required />
                                </div>
                                <div className="form-group">
                                    <label className="form-label">Gender</label>
                                    <select id="custom-select" class="form-control custom-select" {...register('gender')} required>
                                        <option selected>Select Gender</option>
                                        <option value="Male">Male</option>
                                        <option value="Female">Female</option>
                                        <option value="Others">Others</option>
                                    </select>
                                </div>
                            </div>


                            <div className="page-separator">
                                <div className="page-separator__text">Program Information</div>
                            </div>

                            <div className="col-md-8 pt-12pt">
                                <div className="form-group">
                                    <label className="form-label">Cohort</label>
                                    <select id="custom-select"
                                        class="form-control custom-select" {...register('cohort')} required>
                                        <SelectCohort />
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label className="form-label">Program</label>
                                    <select id="custom-select"
                                        class="form-control custom-select" {...register('program')} required>
                                        <SelectProgram />
                                    </select>
                                </div>
                            </div>
                            <button className={`btn btn-primary m-12pt ${isLoading ? "is-loading is-loading-sm disabled" : " "}`} type="submit">Register Student</button>
                        </form>
                    </div>

                </div>
                {/* // END Page Content */}
                <Footer />
            </div>
            <Navbar />
        </div>
    );
}

export default Student;
